import modules from '../helpers/modules';

export function widget3DConfiguration() {
    let iFrame = document.querySelector('[data-id="3DWidget"]'),
        tabNav = document.querySelectorAll('[data-auth-component="tab-nav"]'),
        tabStrapType = document.querySelector('[data-tab-id="tab-strap-type"]'),
        tabStrapColor = document.querySelector('[data-tab-id="tab-strap-color"]'),
        strapType = document.querySelectorAll('[data-strap-type]'),
        strapColor = document.querySelectorAll('[data-static-option-id]'),
        addStrapColor = document.querySelectorAll('[data-add-strap-color]'),
        strapColors = document.querySelectorAll('[data-static-option-ids]'),
        fontType = document.querySelectorAll('[name$="engrav_engravMessageFont"]'),
        engravLine1Elem = document.querySelector('[data-engrave-msg="line-one"]'),
        engravLine2Elem = document.querySelector('[data-engrave-msg1="line-two"]'),
        engravLine3Elem = document.querySelector('[data-engrave-msg2="line-three"]'),
        embossElem = document.querySelector('[data-emboss-msg="message"]'),
        embossFontType = document.querySelectorAll('[data-emboss-font-type]'),
        embossFoilType = document.querySelectorAll('[data-emboss-foil-type]'),
        embossDots = document.querySelector('[data-emboss-dots]'),
        backToProduct = document.querySelectorAll('[data-back-to-product]'),
        collapseButtons = document.querySelectorAll('[data-strap-section-colapse]'),
        ctaWrapper = document.querySelector('[data-product-component="actions"]'),
        pdpContainer = document.getElementsByClassName('pdp'),
        tabAdj = document.querySelectorAll('[data-auth-component="tab-adj"]'),
        trinityEngrav = document.querySelectorAll('[data-engrave-type="trinity"]'),
        isPdpPage = pdpContainer && pdpContainer.length > 0;

    const VAS_TYPE_EMBOSSING = 'embossing',
        VAS_TYPE_ENGRAVING = 'engraving',
        VAS_TYPE_BRACELETADJ = 'braceletAdj',
        IFRAME_MESSAGE_SUCCESS = 'SUCCESS',
        VAS_TYPE_TRINITY_ENGRAVING = 'trinityEngraving',
        IFRAME_MESSAGE_AR_CLICKED = 'click_AR_Button';


    function sendMessage(message) {
        if (iFrame) {
            let content = iFrame.contentWindow;
            content.postMessage(JSON.stringify(message), '*');
        }
    }

    function strapFrameLoadForMobile(event) {
        try {
            var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            if ( data.iframeStates == IFRAME_MESSAGE_SUCCESS ) {
                sendMessage({strapId: event.currentTarget.myParam});
                $('#productStrapChooseColorSlider').addClass('iframe-loaded');
            }
        } catch (e) {
            console.log();
        }
    }

    function receiveMessage(event) {
        try {
            var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            if ( data.iframeStates == IFRAME_MESSAGE_SUCCESS ) {
                setVTOButton();
            }
            if ( data.iframeStates == IFRAME_MESSAGE_SUCCESS || data.arStates == IFRAME_MESSAGE_AR_CLICKED ) {
                setQrCodeMessage();
            }
        } catch (e) {
            return false;
        }
        var pid = $('.pdp-main')[0].getAttribute('data-pid');
        var gtmEvent = '';
        if (data.event !== undefined && (data.event === 'productInterchangeableStraps' || data.event === 'virtual_try_on')) {
            gtmEvent = data.event;
        } else if (data.arStates !== undefined && data.arStates === 'click_AR_Button') {
            gtmEvent = 'productAR';
        }

        if (gtmEvent != '') {
            modules.tracking.init(null, {
                trackEvent: gtmEvent,
                trackObject: {
                    asyncURL: window.SFRA.Urls.GTMEventView,
                    asyncParams: {
                        pid: pid
                    }
                }
            });
        }
    }

    if (isPdpPage) {
        window.addEventListener('message', receiveMessage, false);
    }

    function setVTOButton() {
        let content = iFrame.contentWindow,
            vto_button_text = $(iFrame).attr('data-vto-button-text');

        if (vto_button_text != undefined && vto_button_text.length > 0) {
            content.postMessage(JSON.stringify({vto_button_text: vto_button_text}), '*');
        }

    }

    function setQrCodeMessage() {
        let content = iFrame.contentWindow,
            qrCodeMessage = $(iFrame).attr('data-scan-qr-code-message');

        if (qrCodeMessage != undefined && qrCodeMessage.length > 0) {
            content.postMessage(JSON.stringify({qrCodeContent: qrCodeMessage}), '*');
        }

    }

    function sendMessages(message, type, strap) {
        if ($('.webgl-img').hasClass('strapframe')) {
            $('.webgl-img').removeClass('strapframe');
        }
        let frame = strap.strapFrame.closest('.strap-bar__dailog'),
            iframes = $(frame).find('[data-id="3DWidget"]'),
            currentFrame,
            content;
        iframes.addClass('strapframe');
        currentFrame = document.querySelector('.strapframe'),
        content = currentFrame.contentWindow;
        content.postMessage(JSON.stringify(type), '*');
        content.postMessage(JSON.stringify(message), '*');
    }
    function receiveMessageFromIframe(event) {
        try {
            var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            var getDots;
            if (tabNav[0].dataset.vasName === VAS_TYPE_EMBOSSING && data.iframeStates === IFRAME_MESSAGE_SUCCESS) {
                sendMessage({view: 'EMBOSSING'});
                sendMessage({embossingMsg_1: embossElem.value});
                vasFontType(embossFontType, 'load', VAS_TYPE_EMBOSSING);
                embossingFoilType(embossFoilType, 'load');
                if (embossDots.checked) {
                    if (embossElem.value.length > 1 && embossDots.checked) {
                        getDots = embossElem.value.split('').join('.');
                    } else if (embossElem.value.length == 0 && !embossDots.checked) {
                        getDots = embossElem.value;
                    } else if (this.value.length == 1 || !embossDots.checked) {
                        getDots = embossElem.value;
                    }
                    sendMessage({embossingMsg_1: getDots});
                }
            } else if (tabNav[0].dataset.vasName === VAS_TYPE_ENGRAVING && data.iframeStates === IFRAME_MESSAGE_SUCCESS) {
                sendMessage({view: 'ENGRAVING'});
                sendMessage({engravingMsg_1: engravLine1Elem.value});
                sendMessage({engravingMsg_2: engravLine2Elem.value});
                vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
            } else if (tabNav[0].dataset.vasName === VAS_TYPE_TRINITY_ENGRAVING && data.iframeStates === IFRAME_MESSAGE_SUCCESS) {
                sendMessage({view: 'ENGRAVING_TRINITY_1'});
                sendMessage({view: 'ENGRAVING_TRINITY_2'});
                sendMessage({view: 'ENGRAVING_TRINITY_3'});
                sendMessage({engravingMsg_1: engravLine1Elem.value});
                sendMessage({engravingMsg_2: engravLine2Elem.value});
                sendMessage({engravingMsg_2: engravLine2Elem.value});
            } else if (tabNav[0].dataset.vasName === VAS_TYPE_BRACELETADJ && data.iframeStates === IFRAME_MESSAGE_SUCCESS) {
                sendMessage({view: 'STRAP'});
            }
        } catch (e) {
            console.log();
        }
    }
    if (tabNav !== null && tabNav.length > 0) {
        window.addEventListener('message', receiveMessageFromIframe, false);
    }

    function vasFontType(fontType, event, vasType) {
        if (event === 'load') {
            for (var i = 0; i < fontType.length; ++i) {
                if (fontType[i].checked === true) {
                    var FontType = fontType[i].value;
                }
            }
            if (vasType === VAS_TYPE_ENGRAVING) {
                if (FontType == 'Regular') {
                    sendMessage({engravingFont: 'AVANT'});
                } else {
                    sendMessage({engravingFont: 'SCRIPT412'});
                }
            } else if (vasType === VAS_TYPE_EMBOSSING) {
                sendMessage({embossingFont: FontType});
            }
        } else {
            if (vasType === VAS_TYPE_ENGRAVING) {
                if (fontType.value == 'Regular') {
                    sendMessage({engravingFont: 'AVANT'});
                } else {
                    sendMessage({engravingFont: 'SCRIPT412'});
                }
            }
        }
    }

    function embossingFoilType(foilType, event) {
        if (event === 'load') {
            for (var i = 0; i < foilType.length; ++i) {
                if (foilType[i].checked === true) {
                    var embossingFoilType = foilType[i].value;
                }
            }
            if (embossingFoilType == 'true') {
                sendMessage({embossingColor: 'GOLD'});
            } else {
                sendMessage({embossingColor: 'NEUTRAL'});
            }
        } else {
            if (foilType.value == 'true') {
                sendMessage({embossingColor: 'GOLD'});
            } else {
                sendMessage({embossingColor: 'NEUTRAL'});
            }
        }
    }

    function addOrRemoveHiddenClass(ctaWrapperClass) {
        var addRefillButton = document.querySelector('.product-addrefill__button');
        if (addRefillButton && addRefillButton.getAttribute('data-pid') != '') {
            var refillContainer = document.querySelector('[data-product-component="selected-refills"]');
            if (refillContainer && (refillContainer.firstElementChild == null || refillContainer.firstElementChild && refillContainer.firstElementChild.getAttribute('data-sel-refillid') == '')) {
                ctaWrapperClass.classList.remove('hidden');
            } else {
                ctaWrapperClass.classList.add('hidden');
            }
        } else {
            ctaWrapperClass.classList.add('hidden');
        }
        return ctaWrapperClass;
    }

    [].forEach.call(tabNav, currentItem => currentItem.addEventListener('click', function(e) {
        if (e.target.matches('.removeButton') || currentItem.classList.contains('disable--personalisation')) {
            return false;
        } else {
            if (ctaWrapper !== null) {
                if (this.dataset.tabId == 'tab-engrave' && this.dataset.disableconfig !== 'true' && !this.classList.contains('disable--personalisation')) {
                    sendMessage({view: 'ENGRAVING'});
                    ctaWrapper = addOrRemoveHiddenClass(ctaWrapper);
                } else if (this.dataset.tabId == 'tab-emboss') {
                    sendMessage({view: 'EMBOSSING'});
                    ctaWrapper = addOrRemoveHiddenClass(ctaWrapper);
                } else {
                    ctaWrapper.classList.remove('hidden');
                }
            }
            if (this.dataset.tabId == 'tab-strap-color') {
                let selectedColor = document.querySelector('[data-auth-component="strap-colors-tab"] .toggle--active');
                if (selectedColor) {
                    sendMessage({strapId: selectedColor.dataset.strapColor});
                }
            }
        }
    }));

    [].forEach.call(tabAdj, currentItem => currentItem.addEventListener('click', function(e) {
        if (e.target.matches('.removeButton')) {
            return false;
        } else {
            if (ctaWrapper !== null) {
                if (this.dataset.tabId == 'tab-braceletAdj') {
                    sendMessage({view: 'STRAP'});
                    ctaWrapper.classList.add('hidden');
                } else {
                    ctaWrapper.classList.remove('hidden');
                }
            }
        }
    }));

    [].forEach.call(backToProduct, currentItem => currentItem.addEventListener('click', function() {
        if (this.dataset.tabId == 'tab-back-to-product') {
            sendMessage({view: 'DEFAULT'});
            ctaWrapper.classList.remove('hidden');
        } else {
            ctaWrapper.classList.add('hidden');
        }
    }));

    [].forEach.call(strapType, currentItem => currentItem.addEventListener('click', function() {
        document.querySelectorAll('[data-complementry]').innerHTML = 'Straps';
        sendMessage(this.dataset);
    }));

    [].forEach.call(strapColor, currentItem => currentItem.addEventListener('click', function() {
        document.querySelectorAll('[data-complementry]').innerHTML = 'Complimentory Straps';
        if (($('#productStrapChooseColorSlider').hasClass('iframe-loaded')) && ($(window).width() < 768)) {
            sendMessage({strapId: this.dataset.strapColor});
        } else if ($(window).width() < 768) {
            window.addEventListener('message', strapFrameLoadForMobile, false);
            window.myParam = this.dataset.strapColor;
        } else {
            sendMessage({strapId: this.dataset.strapColor});
        }
    }));

    [].forEach.call(addStrapColor, currentItem => currentItem.addEventListener('click', function() {
        sendMessage({strapId: this.dataset.strapColor});
    }));

    [].forEach.call(addStrapColor, currentItem => currentItem.addEventListener('dblclick', function() {
        let thisStrap = $(this).find('[data-additionalstrap-name]');
        thisStrap.click();
    }));

    [].forEach.call(strapColors, currentItem => currentItem.addEventListener('click', function() {
        let _toggle = this.closest('.strap-bar__dailog');
        $(_toggle).find('.pdp-straps__item').removeClass('toggle');
        this.classList.add('toggle');
        document.querySelectorAll('[data-complementry]').innerHTML = 'Complimentory Straps';
        sendMessages({strapId: this.dataset.strapColor}, {strapType: this.dataset.strapType}, {strapFrame: this.closest('.pdp-straps__carousel')});
    }));

    [].forEach.call(fontType, currentItem => currentItem.addEventListener('change', function() {
        vasFontType(currentItem, 'change', VAS_TYPE_ENGRAVING);
    }));

    [].forEach.call(collapseButtons, currentItem => currentItem.addEventListener('click', function() {
        this.closest('[data-auth-component]').classList.remove('toggle--active');
        ctaWrapper.classList.remove('hidden');
        [].forEach.call(tabNav, currentItem => {
            currentItem.classList.remove('toggle--active');
        });
    }));

    if (tabStrapType) {
        tabStrapType.addEventListener('click', () => {
            $('[data-strap-type-carousel]').slick('refresh');
        }, {once: true});
    }

    if (tabStrapColor) {
        tabStrapColor.addEventListener('click', () => {
            $('[data-strap-color-carousel]').slick('refresh');
        }, {once: true});
    }

    if (engravLine1Elem) {
        engravLine1Elem.addEventListener('input', function() {
            sendMessage({engravingMsg_1: this.value});
            vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
        });
    }

    if (engravLine2Elem) {
        engravLine2Elem.addEventListener('input', function() {
            sendMessage({engravingMsg_2: this.value});
            vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
        });
    }

    if (trinityEngrav && trinityEngrav.length > 0) {
        if (engravLine1Elem) {
            engravLine1Elem.addEventListener('focus', function() {
                sendMessage({view: 'ENGRAVING_TRINITY_1'});
            });
            engravLine1Elem.addEventListener('input', function() {
                sendMessage({engravingMsg_1: this.value});
                vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
            });
        }

        if (engravLine2Elem) {
            engravLine2Elem.addEventListener('focus', function() {
                sendMessage({view: 'ENGRAVING_TRINITY_2'});
            });
            engravLine2Elem.addEventListener('input', function() {
                sendMessage({engravingMsg_2: this.value});
                vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
            });
        }

        if (engravLine3Elem) {
            engravLine3Elem.addEventListener('focus', function() {
                sendMessage({view: 'ENGRAVING_TRINITY_3'});
            });
            engravLine3Elem.addEventListener('input', function() {
                sendMessage({engravingMsg_3: this.value});
                vasFontType(fontType, 'load', VAS_TYPE_ENGRAVING);
            });
        }
    }

    if (embossElem) {
        embossElem.addEventListener('input', function() {
            let isWithoutDot,
                embossDotValue;
            if (embossDots.checked) {
                isWithoutDot = false;
            } else {
                isWithoutDot = true;
            }
            if (this.value.length > 1 && !isWithoutDot) {
                embossDotValue = this.value.split('').join('.');
            } else if (this.value.length == 0 && !isWithoutDot) {
                embossDotValue = this.value;
            } else if (this.value.length == 1 || isWithoutDot) {
                embossDotValue = this.value;
            }
            sendMessage({embossingMsg_1: embossDotValue});
            for (var i = 0; i < embossFontType.length; ++i) {
                if (embossFontType[i].checked === true) {
                    var getFontType = embossFontType[i].value;
                }
            }
            for (i = 0; i < embossFoilType.length; ++i) {
                if (embossFoilType[i].checked === true) {
                    var getFoilType = embossFoilType[i].value;
                }
            }
            sendMessage({embossingFont: getFontType});
            sendMessage({embossingColor: getFoilType});
        });
    }

    [].forEach.call(embossFontType, currentItem => currentItem.addEventListener('change', function() {
        sendMessage({embossingFont: this.value});
    }));

    [].forEach.call(embossFoilType, currentItem => currentItem.addEventListener('change', function() {
        embossingFoilType(currentItem, 'change')
    }));
    if (embossDots) {
        embossDots.addEventListener('change', function() {
            var getDots;
            if (embossDots.checked) {
                if (embossElem.value.length > 1 && embossDots.checked) {
                    getDots = embossElem.value.split('').join('.');
                } else if (embossElem.value.length == 0 && !embossDots.checked) {
                    getDots = embossElem.value;
                } else if (this.value.length == 1 || !embossDots.checked) {
                    getDots = embossElem.value;
                }
            } else {
                getDots = embossElem.value;
            }
            sendMessage({embossingMsg_1: getDots});
        });
    }
}
